import { ValueFormatterParams } from 'ag-grid-community';

export const emptyCellFormatter = (params: ValueFormatterParams) => {
    return params.value === undefined || params.value === null || params.value === '' ? '—' : params.value;
};

export const toFixedFormatter = (params: ValueFormatterParams): string => {
    return !params.value ? '—' : parseFloat(params.value).toFixed(6);
};

export const currencyFormatter = (params: ValueFormatterParams) => {
    if (params.value == null || params.value === '' || params.value == 0) return '$0';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(params.value);
};

export const percentageFormatter = (params: ValueFormatterParams) => {
    if (params.value == null || params.value === '' || params.value == 0) return '0%';
    return new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: params.value < 0.00001 ? 4 : 3,
        maximumFractionDigits: 4
    }).format(params.value);
};
